// Requête hors formulaire dont la réponse est un Turbo
// Stream (rendu ici) : paramètres en corps urlencodé, jeton CSRF de la page.
// Renvoie vrai si la réponse est un succès du serveur ; redirigée (session
// expirée, droits), la page de destination est affichée en entier.
import { renderStreamMessage, visit } from '@hotwired/turbo';

export async function streamRequest(url, { method = 'POST', params = {} } = {}) {
    try {
        const response = await fetch(url, {
            method,
            body: new URLSearchParams(params),
            headers: {
                Accept: 'text/vnd.turbo-stream.html',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
            },
            credentials: 'same-origin',
        });
        if (response.redirected) {
            visit(response.url);
            return false;
        }
        if (response.headers.get('Content-Type')?.startsWith('text/vnd.turbo-stream.html')) renderStreamMessage(await response.text());
        return response.ok;
    } catch {
        return false;
    }
}
